import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { Reveal } from '@/components/landing/Reveal'
import { PageOutro, StatusChip, VisionSection, type Status } from '@/components/landing/Section'

/** The Workspace page: one window, whichever model answers. */
export function WorkspacePage() {
  return (
    <>
      <Workspace />
      <PageOutro>
        <h2 className="nv-h2 text-[1.6rem] sm:text-[2rem]">One window for all of it</h2>
        <p className="mx-auto mt-3 max-w-xl text-[15px] leading-relaxed text-brand-body">Install the app and start a conversation that follows you across models.</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link to="/download" className="nv-btn-primary-lg">
            Download NevTan AI <ArrowRight size={16} />
          </Link>
          <Link to="/roadmap" className="nv-btn-outline-lg">See what ships today</Link>
        </div>
      </PageOutro>
    </>
  )
}

function Workspace() {
  return (
    <VisionSection
      id="workspace"
      eyebrow="The workspace"
      title="One window, whichever model answers"
      lede="Text, code, voice, or an image you dropped in stays in one conversation, with one history and one interface. Switching models does not mean switching apps."
    >
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {[
          [
            'Switch models mid-conversation',
            'Move a conversation to a bigger model without starting over.',
            'today',
          ],
          [
            'Streaming answers',
            'Replies appear as they are written, with formatting and code blocks.',
            'today',
          ],
          ['Conversation history', 'Conversations are saved, searchable, and easy to pick up again.', 'today'],
          [
            'Attachments and voice',
            'Files, images, and voice input, as models arrive that support them.',
            'planned',
          ],
        ].map(([title, note, status], index) => (
          <Reveal key={title} delay={index * 70}>
            <div className="h-full rounded-xl border border-brand-line bg-brand-paper p-5 shadow-card">
              <StatusChip status={status as Status} />
              <h3 className="mt-2.5 text-[14px] font-bold text-brand-heading">{title}</h3>
              <p className="mt-1 text-[12.5px] leading-relaxed text-brand-muted">{note}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </VisionSection>
  )
}

